<template>
  <div id="machine">
  <!-- 面包线导航 -->
    <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>机器人设置</el-breadcrumb-item>
        <el-breadcrumb-item>维修记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card >
        <!-- 第一行筛选框 -->
        <el-row :gutter="20">
                <!-- 机器名查询 -->
                <el-col :span="5" >
                    <el-date-picker v-model="repair.createTimeStr"  type="date"  value-format="yyyy-MM-dd"  placeholder="上传日期" class="m-l-30 ell-input"> </el-date-picker>
                </el-col>
                <el-col :span="5" >
                    <el-input placeholder="请输入维修人姓名" v-model="repair.repairman" class="m-l-30 ell-input" ></el-input>
                </el-col>
               
        </el-row>
        <!-- 第二行筛选框 -->
        <el-row :gutter="20" >
                  <!-- 创建时间 -->
        
            <el-col align="middle" >
                <el-button type="primary" @click="searchRepair()">查询</el-button>
                <el-button type="primary" @click="addRepairDialog()">添加</el-button>
                <el-button type="info" @click="clearParams()">重置</el-button>
                <el-button type="primary" @click="returnMissionPlanning()">返回</el-button>
            </el-col>   
        </el-row>
        <!-- 用户列表区域 -->
        <el-table :data="repairList" border  stripe  :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="机器人编号" prop="robotNo" width="250"></el-table-column>
            <el-table-column label="维修人" prop="repairman" width="250"></el-table-column>
            <el-table-column label="电话" prop="phone" width="250"></el-table-column>
            <el-table-column label="详情"  width="150">
                 <template   slot-scope="scope">
                   <el-button type="primary"  size="mini" @click="lookRepair(scope.row.id)">维修详情</el-button>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" prop="createTime" width="150"></el-table-column>
            <el-table-column label="操作" prop="" width="100">
                <template slot-scope="scope">
                    <!-- 删除按钮 -->
                    <el-tooltip effect="dark" content="删除" placement="top" :enterable="false"  >  
                        <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteById(scope.row.id)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
         <!-- 分页区间 -->
        <el-pagination   @current-change="handleCurrentChange"  :current-page.sync="repair.num"  
                :page-size="10"  layout="total, prev, pager, next"  :total="total">
        </el-pagination>
        <!-- 添加设备对话框 -->
        <el-dialog title="添加记录"  :visible.sync="addRepairVisible"  width="50%" @close="addRepairClose">
                <!-- 内容主题主区 -->
                 <el-form ref="addRepairRef" :model="addRepair"  :rules="addRepairRules"  label-width="70px">
                    <el-row>
                        <el-col :span="12" >
                            <el-form-item label="机器编号:"  label-width="25" prop="robotNo">
                                <el-input v-model="addRepair.robotNo"   readonly ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                            <el-form-item label="维修人员:"  label-width="25" prop="repairman">
                                <el-input v-model="addRepair.repairman"  ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row   >
                    <el-row   >
                        <el-col :span="12" >
                            <el-form-item label="联系电话:"  label-width="25"  prop="phone" >
                                <el-input v-model="addRepair.phone"  ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" >
                            <el-form-item label="员工编号:"  label-width="25"  prop="employeeNo" >
                                <el-input v-model="addRepair.employeeNo"  ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row   >
                     <el-row   >
                     <!-- <el-col :span="9" >
                         <input id="fileupload" class="change" type="file" multiple="multiple" @change="getFile($event,'file_avatar')"  style="float:right" />
                    </el-col> -->
                        <el-col :span="15" >
                            <el-form-item label="备注:"  label-width="25" prop="remake"  >
                                <el-input  type="textarea" v-model="addRepair.remake"  :rows="10" style="float:right"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="15" >
                            <el-upload
                                class="upload-demo" :action="actionUrl"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChanged"
                                :before-remove="beforeRemove"
                                multiple
                                :limit="3"
                                :on-exceed="handleExceed"
                                :file-list="fileList">
                                <el-button size="small" type="primary">点击上传</el-button>
                                <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                            </el-upload>
                        </el-col>
                    </el-row   >
                     
              
                </el-form>
                <!-- 底部区 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="addRepairVisible = false">取 消</el-button>
                <el-button type="primary" @click="addRepairData()">确 定</el-button>
            </span>
            
        </el-dialog>
         <!-- 添加设备对话框 -->
        <el-dialog title="维修详情"  :visible.sync="updateRepairVisible"  width="50%" @close="updateRepairClose">
                <!-- 内容主题主区 -->
            <el-form ref="updateRepairRef" :model="updateRepair"  :rules="updateRepairRules" label-width="70px">
                <el-row :gutter="60"  >
                    <el-col :span="9" >
                       <el-form-item label="机器编号:"  label-width="25" prop="robotNo">
                            <el-input v-model="updateRepair.robotNo"  style="float:right" readonly ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9" >
                        <el-form-item label="维修人员:"  label-width="25" prop="repairman">
                            <el-input v-model="updateRepair.repairman"  style="float:right"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="9" >
                        <el-form-item label="联系电话:"  label-width="25"  prop="phone" >
                            <el-input v-model="updateRepair.phone"  style="float:right"></el-input>
                        </el-form-item>
                    </el-col>
                     <el-col :span="9" >
                        <el-form-item label="员工编号:"  label-width="25"  prop="employeeNo" >
                            <el-input v-model="updateRepair.employeeNo"  style="float:right"></el-input>
                        </el-form-item>
                    </el-col>
                     <!-- <el-col :span="9" >
                         <input id="fileupload" class="change" type="file" multiple="multiple" @change="getFile($event,'file_avatar')"  style="float:right" />
                    </el-col> -->
                    <el-col :span="15" >
                        <el-form-item label="备注:"  label-width="25" prop="remake"   >
                            <el-input  type="textarea" v-model="updateRepair.remake"  :rows="10" style="float:right"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="15" >
                        <el-upload
                            class="upload-demo" :action="actionUrl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChanged"
                            :before-remove="beforeRemove"
                             multiple
                            :limit="3"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                            <el-button size="small" type="primary">点击上传</el-button>
                            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                        </el-upload>
                    </el-col>
                </el-row>
            </el-form>
                <!-- 底部区 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateRepairVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateRepairData()">确 定</el-button>
            </span>
        </el-dialog>
    </el-card >
  </div>
</template>

<script>


export default {
  name: 'machine',
  data(){
      var checkphone=(rule,value,cb)=>{
            const  regPhone=/^1(3[0-9]|4[5,7]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,7,8]|8[0-9]|9[1,8,9])\d{8}$/
            if(regPhone.test(value)){
                return cb();
            }
            cb(new Error('请输入合法的手机号!'))
      }
      var checkZF=(rule,value,cb)=>{
            var zF = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(!zF.test(value)){
                return cb();
            }
            cb(new Error('请输入非特殊字符!'))
      }
      var checkRemake=(rule,value,cb)=>{
            var zF = /[`~!@#$%^&*()\-+=<>"{}|\/;'\\[\]·&*（）\-+={}|']/
            if(!zF.test(value)){
                return cb();
            }
            cb(new Error('请输入非特殊字符!'))
      }
       var checkRobotNo=(rule,value,cb)=>{
            const  regrobotNo=/^[0-9a-zA-Z]*$/
            if(regrobotNo.test(value)){
                return cb();
            }
            cb(new Error('请输入数字或字母!'))
      }
      return {
          repair :{
              robotNo:'',
              repairman:'',
              createTimeStr:'',
              num : 1
          },
          addRepair:{
              robotNo:'',
              repairman:'',
              phone:'',
              remake:'',
              employeeNo:''
          },
          addRepairVisible:false,
          total:0,
          addRepairRules:{
            robotNo:[{required: true, message: '请输入机器编号!',  trigger: 'blur' },{ validator : checkRobotNo, trigger: 'blur'}],
            repairman:[{required: true, message: '请输入维修人员!',  trigger: 'blur' },{ min: 2,  max: 16,  message: '长度在 2 到 16 个字符!',   trigger: 'blur' },{ validator : checkZF, trigger: 'blur'}],
            remake:[{required: true, message: '请输入备注信息!',  trigger: 'blur' },{ min: 2,  max: 200,  message: '长度在 2 到 200 个字符!',   trigger: 'blur' },{ validator : checkRemake, trigger: 'blur'}],
            phone:[{required: true, message: '请输入手机号!',  trigger: 'blur' },{ min: 11,  max: 11,  message: '11位数字!',   trigger: 'blur' },{ validator : checkphone, trigger: 'blur'}],
            employeeNo:[{required: true, message: '请输入员工编号!',  trigger: 'blur' },{ min:2,  max: 10,  message: '长度在 2 到 10 个字符!',   trigger: 'blur' }],
          },
          updateRepair:{
              robotNo:'',
              repairman:'',
              phone:'',
              remake:'',
              employeeNo:''
          },
          updateRepairVisible:false,
          updateRepairRules:{
            robotNo:[{required: true, message: '请输入机器编号!',  trigger: 'blur' },{ validator : checkRobotNo, trigger: 'blur'}],
            repairman:[{required: true, message: '请输入维修人员!',  trigger: 'blur' },{ min: 2,  max: 16,  message: '长度在 2 到 16 个字符!',   trigger: 'blur' },{ validator : checkZF, trigger: 'blur'}],
            remake:[{required: true, message: '请输入备注信息!',  trigger: 'blur' },{ min: 2,  max: 200,  message: '长度在 2 到 200 个字符!',   trigger: 'blur' },{ validator : checkRemake, trigger: 'blur'}],
            phone:[{required: true, message: '请输入手机号!',  trigger: 'blur' },{ min: 11,  max: 11,  message: '11位数字!',   trigger: 'blur' },{ validator : checkphone, trigger: 'blur'}],
            employeeNo:[{required: true, message: '请输入员工编号!',  trigger: 'blur' },{ min:2,  max: 10,  message: '长度在 2 到 10 个字符!',   trigger: 'blur' }],
          },
          path:'',
          repairList:[],
          dialogImageUrl: '',
          dialogVisible: false,
          disabled: false,
          formData:new FormData(),
          fileList: [],
          actionUrl:''
      }
  },
   //生命周期函数
  created(){
    this.searchRepair();
    this.init();
  },
  methods:{
        init(){
            this.actionUrl=this.$http.defaults.baseURL+"repair/uploafile";
            window.sessionStorage.setItem("repairFlag",this.$route.query.pageFlag)
        },
        handleChanged(file,fileList){
            this.fileList = fileList
        },
        handleRemove(file, fileList) {
           this.fileList = fileList
        },
        handlePreview(file) {
            console.log(file);
            if(file.url== undefined){
                document.location.href =window.location.origin+ file.response.result
            }else{
                document.location.href =window.location.origin +file.url
            }
            
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${ file.name }？`);
        },
        updateRepairData(){
            var newList = []
            if(this.fileList.length>0){
                this.fileList.forEach(item =>{
                    var newItem={name:'',url:''};
                    newItem.name=item.name;
                    if(item.response==undefined){
                        newItem.url=item.url;
                    }else{
                        newItem.url=item.response.result;
                    }
                    newList.push(newItem)
                })
            }
            if(this.updateRepair.remake.length!==undefined && this.updateRepair.remake.length>500){
                return this.$message.error("备注过长,请重新输入!");
            }
            
            
            this.$refs.updateRepairRef.validate(  valid => {
                    if(!valid){  return;}
                    this.formData.append("id",this.updateRepair.id)
                    this.formData.append("robotNo",this.updateRepair.robotNo)
                    this.formData.append("repairman",this.updateRepair.repairman)
                    this.formData.append("phone",this.updateRepair.phone)
                    this.formData.append("remake",this.updateRepair.remake)
                    this.formData.append("employeeNo",this.updateRepair.employeeNo)
                    this.formData.append("fileListJson",JSON.stringify(newList))
                    let config = {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    };
                    this.$http.post('/repair/updateRepair',this.formData, config)
                    .then(response => {
                            if (response.data.code === 200) {
                                this.$message.success("更新成功!");
                                this.updateRepairVisible=false;
                                return this.searchRepair()
                            }else{
                                return this.$message.error(response.data.message);
                            }
                        }).catch(failResponse => {

                    })
                    this.formData=new FormData();
             })
           
        },
        lookRepair(val){
            this.$http.get('/repair/getRepair',{params :{ id :  val }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.updateRepair=response.data.result;
                        if(response.data.result.fileListJson !== undefined && response.data.result.fileListJson !== ''){
                            this.fileList=JSON.parse(response.data.result.fileListJson);
                        }
                        this.updateRepairVisible=true;
                        
                    }else{
                        return this.$message.error(response.data.msg);
                    }
                }).catch(failResponse => {

            })
        },
       //返回机器设置页
        returnMissionPlanning(){
            var repairFlag=window.sessionStorage.getItem('repairFlag')
            if(repairFlag==="1"){
                this.$router.replace({path: '/missionPlanning'})
            }
            if(repairFlag==="2"){
               this.$router.replace({path: '/robotManage'+'?id='+this.$route.query.id})
            }
        },
        addRepairClose(){
                this.$refs.addRepairRef.resetFields();
                this.addRepair.robotNo='';
                this.addRepair.repairman='';
                this.addRepair.phone='';
                this.addRepair.remake='';
                this.fileList=[];
        },
        updateRepairClose(){
                this.$refs.updateRepairRef.resetFields();
                this.updateRepair.robotNo='';
                this.updateRepair.repairman='';
                this.updateRepair.phone='';
                this.updateRepair.remake='';
                this.fileList=[];
        },
        //根据id删除
        async deleteById(id){
            //弹框询问
            const confirmRes= await this.$confirm('此操作将永久删除, 是否继续?', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).catch(err =>{
                return err
            })
            if(confirmRes !=='confirm'){
                return this.$message.info('已经取消删除')
            }
            this.$http.get('/repair/deleteRepair',{params :{ id :  id }})
            .then(response => {
                    if (response.data.code === 200) {
                        this.$message.success("删除成功!");
                       this.searchRepair()
                    }else{
                        return this.$message.error(response.data.msg);
                    }
                }).catch(failResponse => {

            })
        },
        addRepairDialog(){
            this.addRepairVisible=true;
            this.addRepair.robotNo=this.$route.query.robotNo;
        },
        getFile(event, file) {
            this.formData.append("file", event.target.files[0]);
            console.log(this.formData)
        },
        addRepairData(){
            var newList = []
            if(this.fileList.length>0){
                this.fileList.forEach(item =>{
                    var newItem={name:'',url:''};
                    newItem.name=item.name;
                    if(item.response==undefined){
                        newItem.url=item.url;
                    }else{
                        newItem.url=item.response.result;
                    }
                    newList.push(newItem)
                })
            }
            if(this.addRepair.remake.length!==undefined && this.addRepair.remake.length>500){
                return this.$message.error("备注过长,请重新输入!");
            }
            if(this.addRepair.repairman === ''){
                return this.$message.error("请输入维修人员名称!");
            }
            if(this.addRepair.phone === ''){
                return this.$message.error("请输入电话号码!");
            }
            if(this.addRepair.employeeNo === ''){
                return this.$message.error("请输入员工编号!");
            }
            if(this.addRepair.remake === ''){
                return this.$message.error("请输入备注信息!");
            }
            if(JSON.stringify(newList) ===''  ){
                return this.$message.error("请上传文件!");
            }
            
            this.$refs.addRepairRef.validate(  valid => {
                if(!valid){  return;}
                this.formData.append("robotNo",this.addRepair.robotNo)
                this.formData.append("repairman",this.addRepair.repairman)
                this.formData.append("phone",this.addRepair.phone)
                this.formData.append("remake",this.addRepair.remake)
                this.formData.append("employeeNo",this.addRepair.employeeNo)
                this.formData.append("fileListJson",JSON.stringify(newList))
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                this.$http.post('/repair/addRepair',this.formData, config)
                .then(response => {
                        if (response.data.code === 200) {
                            this.addRepairVisible = false

                            this.searchRepair()
                        }else{
                            return this.$message.error(response.data.message);
                        }
                    }).catch(failResponse => {

                })
                this.formData=new FormData();
            })
            
        },
        //点击指定页码跳转
        handleCurrentChange(page){
            this.repair.num=page;
            this.searchRepair();
        },
        clearParams(){
          this.repair.robotNo='';
          this.repair.createTimeStr='';
          this.repair.repairman='';
        },
        //查询日志
        searchRepair(){
            //this.path=window.location.origin
            var check = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/
            if(check.test(this.repair.robotNo)||check.test(this.repair.repairman)){
                return this.$message.error("请输入非特殊字符!");
            }
            if(this.$route.query.robotNo==undefined){
                return this.$message.error("参数异常!");
            }
            this.repair.robotNo=this.$route.query.robotNo;
            this.$http.post('/repair/selectRepair',JSON.stringify(this.repair))
            .then(response => {
                    if (response.data.code === 200) {
                       this.repairList=response.data.result.data;
                       this.total=response.data.result.total;
                    }else{
                        return this.$message.error(response.data.message);
                    }
                }).catch(failResponse => {

            })
        },
      
  }
  
}
</script>

<style lang="less" scoped>
.el-input {
    width: 150px;
}
.ell-input {
    width: 200px;
}
.m-l-30 {
  margin-left: 30px !important;
}

.el-row {
    margin-bottom: 20px;
    display: flex;
    flex-wrap: wrap
}

.ell-row {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap
}
html,body,.XSDFXPage{
        width: 50%;
        height: 50%;
        overflow: hidden;
        margin: 0px auto;
        font-family: "微软雅黑";
}


.el-table{
    font-size: 10px;
    height:'20px';
    padding:'0px'
}
/deep/  .el-form-item__label {
  font-size: 18px;
  font-weight: 800;
}
</style>


// WEBPACK FOOTER //
// src/components/robot/Repair.vue